// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2697":"01cc67b9122a30ee","7553":"0f383c98a39f20c4","8378":"082ec88fd31d245f"}[chunkId] + ".css";
};